// extracted by mini-css-extract-plugin
module.exports = {"avatar":"Avatar-module_avatar_3HZRv","active":"Avatar-module_active_zNOYS","inactive":"Avatar-module_inactive_waOzS"};